import * as React from 'react';

import styled, { css } from 'styled-components';

import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import Typography from '../typography';
import { Link } from 'react-scroll';

export interface SidebarItemProps {
  className?: string;
  children?: any;
  active?: boolean;
  done?: boolean;
  route?: string;
  disabled?: boolean;
  push: any;
  soon?: boolean;
  hasSubItem?: boolean;
  isSubItem?: boolean;
  error?: boolean;
  hideLineOnHover?: boolean;
}

export const SidebarItem: React.FC<SidebarItemProps> = (props) => {
  const scrollRoutes = ['general', 'links', 'tour'];
  const handleClick = () => {
    if (props.route && !props.disabled) {
      props.push(props.route);
    }
    return false;
  };

  return (
    <div className={props.className} onClick={handleClick}>
      {scrollRoutes.includes(props.route ? props.route : '') ? (
        <Link to={!props.disabled && props.route} spy={true} smooth={true} duration={500}>
          {props.children}
        </Link>
      ) : (
        props.children
      )}
      {props.soon ? (
        <HintText className="soon" weight="400" type="small">
          Soon
        </HintText>
      ) : null}
    </div>
  );
};

const HintText = styled(Typography)`
  color: ${({ theme }) => theme.colors.hintText};
`;

export default connect(null, { push })(styled(SidebarItem)`
  position: relative;
  margin-bottom: 20px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);

    background-color: ${({ theme }) => theme.colors.tertiary};
    width: 5px;
    height: 5px;
    border-radius: 50%;
    transition: background-color
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`},
      width
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`},
      opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`},
      border-radius
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};

    ${(props) =>
      props.error
        ? css`
            background-color: ${({ theme }) => theme.colors.error};
          `
        : null}
  }

  ${(props) =>
    props.hideLineOnHover
      ? css`
          &:hover {
            &:after {
              opacity: 0;
            }
          }
        `
      : null}

  ${(props) =>
    props.hasSubItem
      ? css`
          &:after {
            top: 8px;
          }
        `
      : null}

  ${(props) =>
    props.isSubItem
      ? css`
          margin: 10px 0 10px 10px;
          &:after {
            content: none;
          }
        `
      : null}

  ${(props) =>
    props.active
      ? css`
          &:after {
            width: 12px;
            background-color: ${({ theme }) => theme.colors.primary};
            border-radius: ${({ theme }) => theme.general.borderRadius};
          }
        `
      : null}

  ${(props) =>
    props.done
      ? css`
          &:after {
            background-color: ${({ theme }) => theme.colors.success};
          }
        `
      : null}

  ${(props) =>
    props.disabled
      ? css`
          cursor: not-allowed;
          &:after {
            opacity: 0.5;
          }
        `
      : null}

  ${(props) =>
    props.soon
      ? css`
          &:after {
            content: none;
          }

          .soon {
            padding: 5px 14px;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(0, -50%);
            background: ${({ theme }) => theme.colors.hint};
            border-radius: 12px;
            opacity: 1;
          }
        `
      : null}
`);
